import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

export default function OpenUrlPopUp({ url }) {
  const auth = useSelector((state) => state.auth);
  const { t } = useTranslation("components");
  return (
    <div
      className="modal fade"
      id="OpenUrlPopUp"
      role="dialog"
      data-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-preview">
        {/* <button type="button" className="close" data-dismiss="modal">
        &times;
      </button> */}
        <div className="modal-content">
          <div className="modal-body">
            <div className="profile-video">
              {/* <img src="images/img-video.png" alt="img-video.png" /> */}
            </div>
            <h3>
              {/* <strong>{userDetails}</strong> */}
              {t("openUrlPopup.title")}
            </h3>
            <div className="bution-close-accept">
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="join-btn"
              >
                <img src="images/video-call.png" alt="video-call.png" />
                {t("openUrlPopup.join")}
              </a>
            </div>
            {auth.role === "client" && (
              <p className="mt-2">
                <Trans i18nKey="openUrlPopup.havingTrouble" ns="components" components={{ a: <Link to="/appointments" /> }} />
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
